export const getUrl = () => {
  const url = process.env.NEXT_PUBLIC_VERCEL_URL
    ? process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
      ? "https://" + "zote.africa"
      : "https://" + process.env.NEXT_PUBLIC_VERCEL_URL
    : "http://localhost:3000";

  return url;
};

export const getOGimage = () => {
  return "https://firebasestorage.googleapis.com/v0/b/ulaafrica.appspot.com/o/assets%2Fzote_cover_1200x630.png?alt=media&token=ff5c5b7e-f5b2-4341-831a-8888fab04973";
};
